import _ from 'underscore';

// Expect in form of : [{ Key: 'PANNumber', Value: '1234'}, { Key: 'GSTINNumber', Value: '3456' }]
export const MTToUITaxInfo = (mtObject) => {
  const obj = {};
  _.each(mtObject, (entry) => { obj[entry.Key] = entry.Value; });
  return obj;
};

// Expect in form of : { PANNumber: '1234', GSTINNumber: '3456' }
export const UIToMTTaxInfo = uiObject =>
  _.map(uiObject, (Value, Key) => ({ Key, Value }));

// Expect in form of : { taxCertifications: [{ id: fileId, displayName: 'certName.pdf', guid: 'ABCD' }], executionDate, declineReasonType }
export const UIToMTTaxCertificate = (uiTaxCertificate) => {
  if (_.isEmpty(uiTaxCertificate)) {
    return null;
  }

  const { taxCertifications, reverseChargeDocuments } = uiTaxCertificate;

  return {
    TaxCertifications: !_.isEmpty(taxCertifications)
      ? _.map(taxCertifications, ({ guid = null, displayName = null }) => ({ FileGuid: guid, FileName: displayName }))
      : [],
    ReverseChargeDocuments: !_.isEmpty(reverseChargeDocuments)
      ? _.map(reverseChargeDocuments, ({ guid = null, displayName = null }) => ({ FileGuid: guid, FileName: displayName }))
      : [],
  };
};

// Expect in form of : { TaxCertifications: [{ FileGuid: 'ABCD', FileName: fileName }]Status, TaxCertificationBlobName }
export const MTToUITaxCertificate = (mtTaxCertObject) => {
  const {
    TaxCertifications: taxCertifications,
    ReverseChargeDocuments: reverseChargeDocuments,
    Status: status,
  } = mtTaxCertObject || {};

  return {
    taxCertifications: _.chain(taxCertifications)
      .map(({ FileGuid, FileName }) => ({
        id: FileGuid,
        displayName: FileName,
        guid: FileGuid,
      }))
      .value(),
    reverseChargeDocuments: _.chain(reverseChargeDocuments)
      .map(({ FileGuid, FileName }) => ({
        id: FileGuid,
        displayName: FileName,
        guid: FileGuid,
      }))
      .value(),
    status,
  };
};
